// Copyright (c) 2016 Deere & Company

import './dealer-search.scss';
import {FormattedMessage, injectIntl, intlShape} from 'react-intl';
import React, {Component, PropTypes} from 'react';
import {
    createErrorObject,
    errorAlertBar
} from '../../../shared/services/alert-bar';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import DealerSearchCriteria from './dealer-search-criteria';
import DealerSearchHeader from './dealer-search-header';
import DealerSearchParams from './../state/dealer-search-params';
import DealerSearchResult from './dealer-search-result';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';

function handleDealerSearchClick() {

    const {formatMessage} = this.intl;

    if (this.isDealerSearchValid) {

        this.actions.updateDealerResults(this.searchParams);

    } else {

        errorAlertBar(createErrorObject(formatMessage({id: 'DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT'})));

    }

}

function handleDealerSearchInputChange(name, value) {

    const processedValue = (name === 'account') ? value.toUpperCase() : value;

    this.actions.updateSearchParams(name, processedValue);

}

function handleDealerSearchInputDivisionChange(value) {

    this.actions.updateSearchDivisionParam(value);

}

function handleDealerSelectClick(dealer) {

    if (this.children && this.children[1] === true) {

        const childernFucntion = this.children[0];

        childernFucntion(dealer);

    } else {

        this.actions.updateNewTransferNewDealer(dealer);

    }
    this.actions.updateDealerSearchModalVisibility(this.isModalVisible);

}

class DealerSearch extends Component {

    componentWillMount() {

        this.props.actions.resetDealerResults();
        this.props.actions.resetSearchParams();
        this.props.actions.updateDivisionParams(this.props.isSapUp);

    }

    render() {

        const {dealers} = this.props;

        let dealerResults;

        if (dealers.length) {

            dealerResults = dealers.map(dealer =>
                <DealerSearchResult
                    dealer={dealer}
                    key={dealer.account}
                    onDealerSelectClick={this.props::handleDealerSelectClick}
                />
            );

        } else if (this.props.hasSearchRun) {

            dealerResults = (
                <span className='empty'>
                    <FormattedMessage id='NO_RESULTS_FOUND'/>
                </span>
            );

        }

        return (
            <section className='dealer-search'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <DealerSearchHeader onDealerSearchClick={this.props::handleDealerSearchClick}/>
                <DealerSearchCriteria
                    division={this.props.division}
                    onDealerSearchDivisionInput={this.props::handleDealerSearchInputDivisionChange}
                    onDealerSearchInput={this.props::handleDealerSearchInputChange}
                    searchParams={this.props.searchParams}
                />
                <span className='dealer-search-results'>{dealerResults}</span>
            </section>
        );

    }

}

DealerSearch.displayName = 'DealerSearch';
DealerSearch.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    dealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    division: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    hasSearchRun: PropTypes.bool.isRequired,
    intl: intlShape.isRequired,
    isDealerSearchValid: PropTypes.bool.isRequired,
    isModalVisible: PropTypes.bool.isRequired,
    isSapUp: PropTypes.bool,
    searchParams: PropTypes.instanceOf(DealerSearchParams).isRequired
};

export default injectIntl(DealerSearch);



// WEBPACK FOOTER //
// ./src/product/dealer-search/components/dealer-search.js